import React, { useEffect, useState, useMemo } from 'react';
import { useRouter } from 'next/router';

import { serverSideTranslation } from '../../../util/next';
import { getPageContent } from '../../../api/pagesApi';

import Page from '../../../components/Layout/Page';
import Breadcrumb from '../../../components/Breadcrumb';
import { PlayGroundProgressList } from '../../../modules/Playground';
// import PlaygroundDetailData from '../../../data/playgroundDetails';
import { genShareConfig } from '../../../components/Share/use-config-share';
import { getClientPlaygroundData } from '../../../api/playgroundApi';
import { PGContextProvider } from '../../../components/GongyiProvider/PlaygroundCtxProvider';

import styles from './index.module.scss';

interface Props {
  pageContentData: any;
  locale: string;
}

const PlayGroundProgress = (props: Props) => {
  const { pageContentData, locale } = props;
  const { pageContent, shareContent } = pageContentData;
  const router = useRouter();
  const [pgData, setPgData] = useState<any>(null);
  if (locale === 'en-US') {
    router.replace('/public-welfare', '/public-welfare', {
      locale,
    });
  }

  const {
    PGDatailBgImg,
    PGDatailNavtitle,
    PGDatailNavSubtitle,
    PGDatailNavTtitle,
    PGDetailTitle,
    prePageText,
    nextPageText,
    PGmodalCardLabel,
    PGModalCardTabs,
    // PGDetailSubTitle,
    PGDetailSubTitleNew,
  } = pageContent || {};
  const navData = {
    bgUrl: PGDatailBgImg,
    data: [
      { text: PGDatailNavtitle, link: '/public-welfare' },
      { text: PGDatailNavSubtitle, link: '/public-welfare/playground' },
      { text: PGDatailNavTtitle },
      { text: PGDetailTitle },
    ],
  };

  useEffect(() => {
    getClientPlaygroundData().then(({ code, data }) => {
      if (code === 0) {
        setPgData({
          closeYear: data.closeYear,
          closeMonth: data.closeMonth,
          playgroundCnt: data.playgroundCnt || 559,
          provinceCount: data.provinceCount || 15,
        });
      }
    });
  }, []);

  const subTitleName = useMemo(() => {
    if (!pgData || !PGDetailSubTitleNew) return null;

    return PGDetailSubTitleNew.replaceAll('$closeYear$', pgData.closeYear)
      .replaceAll('$closeMonth$', pgData.closeMonth)
      .replaceAll('$playgroundCnt$', pgData.playgroundCnt)
      .replaceAll('$provinceCount$', pgData.provinceCount);
  }, [pgData, PGDetailSubTitleNew]);

  return (
    <PGContextProvider value={{ PGmodalCardLabel, PGModalCardTabs }}>
      <Page title={shareContent.shareTitle}>
        <div className={styles.content}>
          <div className="lg:m-auto lg:max-w-screen-xl xl:px-5">
            <Breadcrumb subTitle={subTitleName} {...navData} />
          </div>
          <PlayGroundProgressList lanType={locale} prePageText={prePageText} nextPageText={nextPageText} />
        </div>
      </Page>
    </PGContextProvider>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/gongyi/playground/details',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_hthau0px',
        locale,
        ...pageContentData?.shareContent,
      },
      locale,
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['home', 'cookie', 'common', 'playgroundDetail'])),
    },
  };
}
export default PlayGroundProgress;
